import React from 'react'
import PropTypes from 'prop-types'

import ContentHolder from '../../ui/ContentHolder'
import styles from './styles.scss'

const Commission = (props) => {
  const {
    campaignProposal: { commission_fee, commission_structure },
  } = props

  if (!commission_fee) return null

  return (
    <div className={styles.root}>
      <ContentHolder>
        <div className={styles.content}>
          <h1>Selling Fees:</h1>

          <p className={styles.intro}>
            To ensure we can provide the best service and achieve the best possible price for your property our fee for
            selling is {commission_fee}% inc GST. The services we provide include but are not limited to:
          </p>

          <ul className={styles.list}>
            <li>Negotiating with potential buyers to increase the value of your transaction.</li>
            <li>Organising marketing for your property across our own database and internet portals.</li>
            <li>
              Consultation and our professional recommendations to increase the buyer pool interested in your property.
            </li>
            <li>Organisation and consultation during the settlement period.</li>
          </ul>

          <p style={{ marginTop: 30 }}>Commission:</p>
          
          <span className={styles.priceLarge}>
            {commission_fee}%
          </span>
          
          {commission_structure && <p>{commission_structure}</p>}
        </div>
      </ContentHolder>
    </div>
  )
}

Commission.propTypes = {
  campaignProposal: PropTypes.object.isRequired,
}

export default Commission
